import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=51ec9b50&scoped=true"
var script = {}
import style0 from "./Accordion.scss?vue&type=style&index=0&id=51ec9b50&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ec9b50",
  null
  
)

export default component.exports